import React from "react";
import { Link } from "react-router-dom";
import MenuBtn from "../../components/menuBtn/menuBtn.component.jsx";
import UserWelcome from "../../components/userWelcome/userWelcome.component.jsx";
import MenuItems from "../../containerSmall/menuItems/menuItems.component.jsx";
import UserInfoMobile from "../../containerSmall/userInfoMobile/userInfoMobile.component.jsx";
import { FixeMenuStyled } from "./fixedMenu.styles.js";
import useMediaQuery from "../../hooks/useMediaQuery";
import ImageSlider from "../../containerSmall/imageSlider/imageSlider.component.jsx";
const FixedMenu = () => {
  let size = useMediaQuery();

  return (
    <FixeMenuStyled>
      <UserWelcome />
      {["xm"].includes(size) && <UserInfoMobile />}
      <MenuItems />
      <ImageSlider />
      <Link to="/app2/vehicle-category">
        <MenuBtn title="درخواست خودرو" />
      </Link>
    </FixeMenuStyled>
  );
};

export default FixedMenu;
